/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Checkbox } from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';

import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  MinDate,
  MaxDate,
  dateFormatForDatePicker,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import { validDate } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../SharedModules/DateUtilities/DateUtilities';
import { getRebateProgramCode } from '../store/actions';

const DuplicateContractModal = (props) => {
  const { onClickDuplicateContractDialog, onCloseDuplicateContract, planType } =
    props;
  const maintainContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.maintainContractState
  );
  const dispatch = useDispatch();
  const getRebateProgramCodeValue = (values) =>
    dispatch(getRebateProgramCode(values));
  const rebateProgramCode = useSelector(
    (state) => state.sharedState.ContractReducer?.rebateProgramCode?.data
  );
  const [formValues, setFormValues] = React.useState({
    fromDate: null,
    toDate: null,
    rebateProgramCode: '-1',
    drugPricing: false,
  });
  const [errorMessages, setErrorMessages] = React.useState([]);
  React.useEffect(() => {
    getRebateProgramCodeValue(planType);
  }, []);
  const validationFields = () => {
    let errorArray = errorMessages || [];
    if (
      formValues.rebateProgramCode === '-1' ||
      formValues.rebateProgramCode === null
    ) {
      errorArray = errorArray?.filter(
        (item) => item.fieldName !== 'rebateProgramCode'
      );
      errorArray.push({
        fieldName: 'rebateProgramCode',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED_REQ,
      });
    } else {
      errorArray = errorArray?.filter(
        (item) => item.fieldName !== 'rebateProgramCode'
      );
    }
    if (formValues.fromDate === '' || formValues.fromDate === null) {
      errorArray = errorArray?.filter((item) => item.fieldName !== 'fromDate');
      errorArray.push({
        fieldName: 'fromDate',
        message: constantMessageData.START_DATE_REQUIRED,
      });
    } else if (
      formValues.fromDate &&
      validDate(new Date(formValues.fromDate)) === false
    ) {
      errorArray = errorArray?.filter((item) => item.fieldName !== 'fromDate');
      errorArray.push({
        fieldName: 'fromDate',
        message: constantMessageData.DATE_INVALID_FORMAT_ERROR,
      });
    } else if (
      formValues.fromDate &&
      compareTwoDatesGreaterThanOrEqual(formValues.fromDate, moment(MinDate))
    ) {
      errorArray = errorArray?.filter((item) => item.fieldName !== 'fromDate');
      errorArray.push({
        fieldName: 'fromDate',
        message: constantMessageData.MINIMUM_START_DATE,
      });
    } else {
      errorArray = errorArray?.filter((item) => item.fieldName !== 'fromDate');
    }
    if (
      formValues.toDate !== null &&
      validDate(new Date(formValues.toDate)) === false
    ) {
      errorArray = errorArray?.filter((item) => item.fieldName !== 'toDate');
      errorArray.push({
        fieldName: 'toDate',
        message: constantMessageData.DATE_INVALID_FORMAT_ERROR,
      });
    } else if (
      formValues.toDate &&
      compareTwoDatesGreaterThanOrEqual(
        formValues.toDate,
        moment(formValues.fromDate || MinDate)
      )
    ) {
      errorArray = errorArray?.filter((item) => item.fieldName !== 'toDate');
      errorArray.push({
        fieldName: 'toDate',
        message:
          constantMessageData.END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
      });
    } else {
      errorArray = errorArray?.filter((item) => item.fieldName !== 'toDate');
    }
    setErrorMessages([...new Set(errorArray)]);
    if (errorArray && errorArray?.length > 0) {
      return false;
    }
    if (errorArray?.length === 0) {
      let err = [];
      if (
        compareTwoDatesGreaterThanOrEqual(
          formValues.toDate,
          maintainContractState.contractStartDate
        ) &&
        !compareTwoDatesGreaterThanOrEqual(
          formValues.fromDate,
          maintainContractState.contractEndDate
        ) &&
        formValues.toDate != null
      ) {
        err.push({
          fieldName: 'duplicateError',
          message: constantMessageData.CONTRACT_DULPICATE_ERROR,
        });
        setErrorMessages([...new Set(err)]);
      } else if (
        compareTwoDatesGreaterThanOrEqual(
          formValues.fromDate,
          maintainContractState.contractEndDate
        ) &&
        !compareTwoDatesGreaterThanOrEqual(
          formValues.toDate,
          maintainContractState.contractStartDate
        ) &&
        formValues.toDate != null
      ) {
        err.push({
          fieldName: 'duplicateError',
          message: constantMessageData.CONTRACT_DULPICATE_ERROR,
        });
        setErrorMessages([...new Set(err)]);
      } else if (
        compareTwoDatesGreaterThanOrEqual(
          formValues.fromDate,
          maintainContractState.contractStartDate
        ) &&
        formValues.toDate == null
      ) {
        err.push({
          fieldName: 'duplicateError',
          message: constantMessageData.CONTRACT_DULPICATE_ERROR,
        });
        setErrorMessages([...new Set(err)]);
      } else {
        setErrorMessages([]);
        return true;
      }
    }
  };
  const onSubmit = () => {
    if (validationFields()) {
      onClickDuplicateContractDialog(
        formValues.fromDate,
        formValues.toDate,
        formValues.rebateProgramCode,
        formValues.drugPricing
      );
    }
  };
  const onClose = () => {
    onCloseDuplicateContract();
  };
  //on change fields
  const onChangeDateField = (d, name) => {
    let errorArray = errorMessages || [];
    errorArray = errorArray?.filter(
      (item) => item.fieldName != 'duplicateError'
    );
    if (d !== 'Invalid Date') {
      setFormValues({ ...formValues, [name]: d });
      if (name == 'fromDate') {
        if (
          formValues.toDate &&
          compareTwoDatesGreaterThanOrEqual(formValues.toDate, moment(d))
        ) {
          errorArray = errorArray?.filter(
            (item) => item.fieldName !== 'toDate'
          );
          errorArray.push({
            fieldName: 'toDate',
            message:
              constantMessageData.END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
          });
        } else {
          errorArray = errorArray?.filter(
            (item) => item.fieldName !== 'toDate'
          );
        }
      }
    }
    setErrorMessages([...new Set(errorArray)]);
  };
  // call on Blur event filed level
  const handleOnBlurDate = (d, name) => {
    let errorArray = errorMessages || [];
    errorArray = errorArray?.filter(
      (item) => item.fieldName != 'duplicateError'
    );
    let { value } = d.target;
    if (d.target.value && d.target.value.length > 5) {
      const data = d.target.value.split('/');
      if (data[2].split('_').length === 3) {
        value = moment(d.target.value, 'MM/DD/YY').format('MM/DD/YYYY');
      }
    }
    if ((value === '' || value === null) && name === 'fromDate') {
      errorArray = errorArray?.filter((item) => item.fieldName !== name);
      errorArray.push({
        fieldName: name,
        message: constantMessageData.START_DATE_REQUIRED,
      });
    } else if (value && validDate(new Date(value)) === false) {
      errorArray = errorArray?.filter((item) => item.fieldName !== name);
      errorArray.push({
        fieldName: name,
        message: constantMessageData.DATE_INVALID_FORMAT_ERROR,
      });
    } else if (name === 'fromDate') {
      if (value && compareTwoDatesGreaterThanOrEqual(value, moment(MinDate))) {
        errorArray = errorArray?.filter((item) => item.fieldName !== name);
        errorArray.push({
          fieldName: name,
          message: constantMessageData.MINIMUM_START_DATE,
        });
      } else {
        errorArray = errorArray?.filter((item) => item.fieldName !== name);
      }
      if (
        formValues.toDate &&
        compareTwoDatesGreaterThanOrEqual(formValues.toDate, moment(value))
      ) {
        errorArray = errorArray?.filter((item) => item.fieldName !== 'toDate');
        errorArray.push({
          fieldName: 'toDate',
          message:
            constantMessageData.END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
        });
      } else {
        errorArray = errorArray?.filter((item) => item.fieldName !== 'toDate');
      }
    } else if (name === 'toDate') {
      if (
        value &&
        compareTwoDatesGreaterThanOrEqual(
          value,
          moment(formValues.fromDate || MinDate)
        )
      ) {
        errorArray = errorArray?.filter((item) => item.fieldName !== name);
        errorArray.push({
          fieldName: name,
          message:
            constantMessageData.END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
        });
      } else {
        errorArray = errorArray?.filter((item) => item.fieldName !== name);
      }
    }
    setErrorMessages([...new Set(errorArray)]);
  };
  // check validation for filed Level
  const handleOnBlurEventOnFields = (e, name) => {
    let errorArray = errorMessages || [];
    if (e.target.value === '-1' || e.target.value === null) {
      errorArray = errorArray?.filter((item) => item.fieldName !== name);
      errorArray.push({
        fieldName: name,
        message: constantMessageData.REBATE_PROGRAM_REQUIRED_REQ,
      });
    } else {
      errorArray = errorArray?.filter((item) => item.fieldName !== name);
    }
    setErrorMessages([...new Set(errorArray)]);
  };

  return (
    <div
      className="lt-common-modal m-2"
      data-testid="DuplicateContractModal-component"
    >
      <DisplayErrorMessages
        errorMessages={[
          ...new Set(
            errorMessages?.length > 0
              ? _.map(errorMessages, (l) => l.message)
              : []
          ),
        ]}
      />
      <div className="row">
        <fieldset className="custom-fieldset">
          <legend className="same-font-family">Select Contract Dates</legend>
          <div className="form-wrapper p-0 mt-2">
            <div className="mui-custom-form input-md field-xl">
              <div className="row">
                <div className="col-6">
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      data-testid="writeOffFrom"
                      className="mandate-fields"
                      id="writeOffDatePop"
                      label="Start Date"
                      required
                      format={dateFormatForDatePicker}
                      inputFormat={dateFormatForDatePicker}
                      mask="__/__/____"
                      minDate={MinDate}
                      maxDate={MaxDate}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: false,
                        autoFill: false,
                      }}
                      placeholder="mm/dd/yyyy"
                      value={formValues.fromDate}
                      onChange={(d) => {
                        onChangeDateField(d, 'fromDate');
                      }}
                      onBlur={(e) => {
                        handleOnBlurDate(e, 'fromDate');
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'from Date',
                      }}
                      onKeyDown={async (e) => {
                        if (e.keyCode == 67) {
                          // copy date
                          await window.navigator?.clipboard.writeText(e?.target?.value);
                        }
                      }}
                      helperText={
                        errorMessages?.length > 0
                          ? [
                              ...new Set(
                                errorMessages
                                  ?.filter((x) => {
                                    return x.fieldName === 'fromDate';
                                  })
                                  .map((item) => {
                                    return item.message;
                                  })
                              ),
                            ]
                          : null
                      }
                      error={
                        errorMessages?.length > 0 &&
                        errorMessages?.filter((x) => {
                          return x.fieldName === 'fromDate';
                        }).length > 0
                          ? [
                              ...new Set(
                                errorMessages
                                  ?.filter((x) => {
                                    return x.fieldName === 'fromDate';
                                  })
                                  .map((item) => {
                                    return item.message;
                                  })
                              ),
                            ]
                          : false
                      }
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div className="col-6">
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      data-testid="writeOffEnd"
                      className="mandate-fields"
                      id="writeOffDatePop"
                      label="End Date"
                      format={dateFormatForDatePicker}
                      inputFormat={dateFormatForDatePicker}
                      mask="__/__/____"
                      minDate={
                        formValues.fromDate ? formValues.fromDate : MinDate
                      }
                      maxDate={MaxDate}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: false,
                        autoFill: false,
                      }}
                      placeholder="mm/dd/yyyy"
                      value={formValues.toDate}
                      onChange={(d) => {
                        onChangeDateField(d, 'toDate');
                      }}
                      onBlur={(e) => {
                        handleOnBlurDate(e, 'toDate');
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'to Date',
                      }}
                      helperText={
                        errorMessages?.length > 0
                          ? [
                              ...new Set(
                                errorMessages
                                  ?.filter((x) => {
                                    return x.fieldName === 'toDate';
                                  })
                                  .map((item) => {
                                    return item.message;
                                  })
                              ),
                            ]
                          : null
                      }
                      error={
                        errorMessages?.length > 0 &&
                        errorMessages?.filter((x) => {
                          return x.fieldName === 'toDate';
                        }).length > 0
                          ? [
                              ...new Set(
                                errorMessages
                                  ?.filter((x) => {
                                    return x.fieldName === 'toDate';
                                  })
                                  .map((item) => {
                                    return item.message;
                                  })
                              ),
                            ]
                          : false
                      }
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div className="col-6">
                  <div className=" with-select">
                    <TextField
                      className="mandate-fields"
                      label="Rebate Program"
                      required
                      data-testid="rebateProgram"
                      fullWidth
                      select
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="rebateProgramCode"
                      value={
                        formValues.rebateProgramCode
                          ? formValues.rebateProgramCode
                          : '-1'
                      }
                      onChange={(e) => {
                        setFormValues({
                          ...formValues,
                          rebateProgramCode: e.target.value,
                        });
                      }}
                      onBlur={(e) => {
                        handleOnBlurEventOnFields(e, 'rebateProgramCode');
                      }}
                      helperText={
                        errorMessages?.length > 0
                          ? [
                              ...new Set(
                                errorMessages
                                  ?.filter((x) => {
                                    return x.fieldName === 'rebateProgramCode';
                                  })
                                  .map((item) => {
                                    return item.message;
                                  })
                              ),
                            ]
                          : null
                      }
                      error={
                        errorMessages?.length > 0 &&
                        errorMessages?.filter((x) => {
                          return x.fieldName === 'rebateProgramCode';
                        }).length > 0
                          ? [
                              ...new Set(
                                errorMessages
                                  ?.filter((x) => {
                                    return x.fieldName === 'rebateProgramCode';
                                  })
                                  .map((item) => {
                                    return item.message;
                                  })
                              ),
                            ]
                          : false
                      }
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {rebateProgramCode && rebateProgramCode.length > 0
                        ? rebateProgramCode.map((item) => {
                            return (
                              <MenuItem
                                key={item.rebateProgramCd}
                                value={item.rebateProgramCd}
                              >
                                {item.rebateProgramCd} - {item.shortDescr}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                </div>
                <div className="col-6">
                  <Form.Group className="col-11" controlId="formBasicCheckbox">
                    <FormControlLabel
                      control={<Checkbox color="primary" />}
                      style={{ marginTop: '27px' }}
                      id="rebate-checkbox"
                      label="Drug Pricing"
                      checked={formValues?.drugPricing}
                      onChange={() => {
                        setFormValues({
                          ...formValues,
                          drugPricing: !formValues.drugPricing,
                        });
                      }}
                    />
                  </Form.Group>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div className="float-right">
        <div className="btn-wrapper my-2 mx-auto">
          <div className="float-right hide-on-print">
            <Button
              onClick={onSubmit}
              className="btn btn-success btn-search mr-2"
              data-testid="filter-search-add-ndc-modal-add-btn"
            >
              <SVGComponent iconName="Icon_awesome-check-circle" />
              Ok
            </Button>
            <Button
              onClick={onClose}
              className="btn btn-cancel btn-primary mr-2"
              data-testid="filter-search-add-ndc-modal-cancel-btn"
              color="primary"
              autoFocus
            >
              <SVGComponent iconName="Icon-cancel" />
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DuplicateContractModal;
